/** Theme identifiers supported by @zyxantech/tux ThemeProvider. */
export const THEME_NAMES = ['tap-dark', 'tap-light', 'scada-dark', 'enterprise-light'] as const

export type ThemeName = (typeof THEME_NAMES)[number]

export const DEFAULT_THEME: ThemeName = 'tap-dark'

/** Themes whose base background is dark — used to toggle the `dark` html class. */
export const DARK_THEMES: ReadonlySet<ThemeName> = new Set(['tap-dark', 'scada-dark'])
